var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { carpoolServiceToUiAdapter, carpoolUiToServiceAdapter } from '../../../../adapters';
import { parkingSplitApi } from '../../apiBase';
export var adminCarpoolApi = parkingSplitApi.injectEndpoints({
    overrideExisting: true,
    endpoints: function (builder) { return ({
        getCarpoolAdmin: builder.query({
            query: function (_a) {
                var carpoolApiBaseUrl = _a.carpoolApiBaseUrl, regionId = _a.regionId, carpoolApiCreateGroupUrlAdmin = _a.carpoolApiCreateGroupUrlAdmin, registrationId = _a.registrationId;
                return ({
                    url: "".concat(carpoolApiBaseUrl).concat(regionId).concat(carpoolApiCreateGroupUrlAdmin, "/").concat(registrationId),
                    method: 'GET',
                });
            },
            transformResponse: function (response) {
                return response && carpoolServiceToUiAdapter(response);
            },
        }),
        getCustomCarpoolReport: builder.query({
            query: function (_a) {
                var carpoolApiBaseUrl = _a.carpoolApiBaseUrl, regionId = _a.regionId, carpoolApiCreateGroupUrlAdmin = _a.carpoolApiCreateGroupUrlAdmin, fromDate = _a.fromDate, toDate = _a.toDate;
                return ({
                    url: "".concat(carpoolApiBaseUrl).concat(regionId).concat(carpoolApiCreateGroupUrlAdmin, "/reports/custom?fromDate=").concat(fromDate, "&toDate=").concat(toDate),
                    method: 'GET',
                    headers: {
                        Accept: 'text/csv',
                    },
                    responseHandler: function (response) { return response.blob(); },
                });
            },
            onQueryStarted: function (_args, _a) {
                var queryFulfilled = _a.queryFulfilled;
                return __awaiter(this, void 0, void 0, function () {
                    var csvBlob, blobUrl, link;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, queryFulfilled];
                            case 1:
                                csvBlob = (_b.sent()).data;
                                blobUrl = window.URL.createObjectURL(csvBlob);
                                link = document.createElement('a');
                                link.href = blobUrl;
                                link.setAttribute('download', "CarpoolRegistrations_".concat(new Date().toISOString(), ".csv"));
                                document.body.appendChild(link);
                                link.click();
                                link.remove();
                                window.URL.revokeObjectURL(blobUrl);
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        getFullCarpoolReport: builder.query({
            query: function (_a) {
                var carpoolApiBaseUrl = _a.carpoolApiBaseUrl, regionId = _a.regionId, carpoolApiCreateGroupUrlAdmin = _a.carpoolApiCreateGroupUrlAdmin;
                return ({
                    url: "".concat(carpoolApiBaseUrl).concat(regionId).concat(carpoolApiCreateGroupUrlAdmin, "/reports/full"),
                    method: 'GET',
                    headers: {
                        Accept: 'text/csv',
                    },
                    responseHandler: function (response) { return response.blob(); },
                });
            },
            onQueryStarted: function (_args, _a) {
                var queryFulfilled = _a.queryFulfilled;
                return __awaiter(this, void 0, void 0, function () {
                    var csvBlob, blobUrl, link;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, queryFulfilled];
                            case 1:
                                csvBlob = (_b.sent()).data;
                                blobUrl = window.URL.createObjectURL(csvBlob);
                                link = document.createElement('a');
                                link.href = blobUrl;
                                link.setAttribute('download', "AllCarpoolRegistrations_".concat(new Date().toISOString(), ".csv"));
                                document.body.appendChild(link);
                                link.click();
                                link.remove();
                                window.URL.revokeObjectURL(blobUrl);
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        postCarpoolAdmin: builder.mutation({
            query: function (_a) {
                var carpoolApiBaseUrl = _a.carpoolApiBaseUrl, regionId = _a.regionId, carpoolApiCreateGroupUrlAdmin = _a.carpoolApiCreateGroupUrlAdmin, requestData = _a.requestData;
                return ({
                    url: "".concat(carpoolApiBaseUrl).concat(regionId).concat(carpoolApiCreateGroupUrlAdmin),
                    method: 'POST',
                    body: carpoolUiToServiceAdapter(requestData),
                    invalidates: ['Posts'],
                });
            },
        }),
        updateCarpoolAdmin: builder.mutation({
            query: function (_a) {
                var carpoolApiBaseUrl = _a.carpoolApiBaseUrl, regionId = _a.regionId, carpoolApiCreateGroupUrlAdmin = _a.carpoolApiCreateGroupUrlAdmin, requestData = _a.requestData, registrationId = _a.registrationId;
                return ({
                    url: "".concat(carpoolApiBaseUrl).concat(regionId).concat(carpoolApiCreateGroupUrlAdmin, "/").concat(registrationId),
                    method: 'PATCH',
                    body: carpoolUiToServiceAdapter(requestData),
                });
            },
        }),
        deleteCarpoolAdmin: builder.mutation({
            query: function (_a) {
                var carpoolApiBaseUrl = _a.carpoolApiBaseUrl, regionId = _a.regionId, carpoolApiCreateGroupUrlAdmin = _a.carpoolApiCreateGroupUrlAdmin, registrationId = _a.registrationId;
                return ({
                    url: "".concat(carpoolApiBaseUrl).concat(regionId).concat(carpoolApiCreateGroupUrlAdmin, "/").concat(registrationId),
                    method: 'DELETE',
                });
            },
        }),
    }); },
});
export var useGetCarpoolAdminQuery = adminCarpoolApi.useGetCarpoolAdminQuery, useGetCustomCarpoolReportQuery = adminCarpoolApi.useGetCustomCarpoolReportQuery, useGetFullCarpoolReportQuery = adminCarpoolApi.useGetFullCarpoolReportQuery, useLazyGetCustomCarpoolReportQuery = adminCarpoolApi.useLazyGetCustomCarpoolReportQuery, useLazyGetFullCarpoolReportQuery = adminCarpoolApi.useLazyGetFullCarpoolReportQuery, usePostCarpoolAdminMutation = adminCarpoolApi.usePostCarpoolAdminMutation, useUpdateCarpoolAdminMutation = adminCarpoolApi.useUpdateCarpoolAdminMutation, useDeleteCarpoolAdminMutation = adminCarpoolApi.useDeleteCarpoolAdminMutation;
